/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';

export default [
  {
    name: 'game',
    path: '/game',
    meta: { auth: AUTH_STATE.LOGGED_IN },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'game_switch' },
    children: [
      {
        name: 'game_switch',
        path: '/games',
        meta: { auth: [AUTH_STATE.LOGGED_IN, AUTH_STATE.UNREGISTERED], title: '切换圈子' },
        component: () => import('@/views/game/switch'),
      },
    ],
  },
] as RouteConfig[];
